import { ref } from "vue";
import axios from "axios";


export default {
  __name: 'TestContainer',
  setup(__props) {

const categories = ref([
  {
    title: "Родители и дети",
    url: "/category/roditeli-i-deti/",
    imageUrl: `https://cdn3.elena-elizarova.ru/59106a03-d553-4cbc-8742-1b6df5a19cae/576.324-pop-min.jpg`,
  },
  {
    title: "Психика человека",
    url: "/category/psihika/",
    imageUrl: `https://cdn3.elena-elizarova.ru/39106a03-d553-4cbc-8742-1b6df5a19cbe/576.324-klin-min.jpg`,
  },
  {
    title: "Саморазвитие",
    url: "/category/samorazvitie/",
    imageUrl: `https://cdn3.elena-elizarova.ru/39106a03-d553-4cbc-8742-1b6df5a19c9e/576.324-brooke-cagle-kvKSL7B6eTo-unsplash.jpg`,
  },
  {
    title: "Отношения",
    url: "/category/otnoshenija/",
    imageUrl: `https://cdn3.elena-elizarova.ru/39106a03-d553-4cbc-8742-1b6df5a19cae/576.324-otn-min.jpg`,
  },
  {
    title: "Заметки психолога",
    url: "/category/zametki/",
    imageUrl: `https://cdn3.elena-elizarova.ru/49106a03-d553-4cbc-8742-1b6df5a19cae/576.324-zametki.jpg`,
  },
  ]);

// const lastArticles = ref([]);

// const apiURL = process.env.API_URL || "https://www.elena-elizarova.ru/api/v1";
// const apiCategoryUrl = `${apiURL}/category/top`; // Получаем URL к API

// //async asyncData({ $axios, $config, error }) {
// axios
//   .get(apiCategoryUrl)
//   .then((itemCategory) => {
//     if (itemCategory.data.length === 0)
//       throw { statusCode: 404, message: "Страница не найдена" };
//     else {
//       categories.value = itemCategory.data.map((item) => {
//         if (item.thumbnailUrl !== undefined) {
//           return {
//             title: item.name,
//             url: `/category/${item.id}/`,
//             imageUrl: `https://cdn.elena-elizarova.ru${item.thumbnailUrl}`,
//           };
//         } else {
//           return { title: item.headline, url: `/article/${item.id}/`, imageUrl: `` };
//         }
//       });
//       //return { data };
//     }
//   })
//   .catch((e) => {
//     if (e.response != undefined && e.response.status == 404) {
//       console.log(e.response.data);
//     }
//     error(e);
//   });

//list.value = res.data;

// const apiArticleUrl = `${apiURL}/article/articles?offset=0&limit=10&status=published&fields=id,name,headline,thumbnailurl`; // Получаем URL к API
// axios
//   .get(apiArticleUrl)
//   .then((itemArticle) => {
//     if (itemArticle.data.length === 0)
//       throw { statusCode: 404, message: "Страница не найдена" };
//     else {
//       lastArticles.value = itemArticle.data.map((item) => {
//         if (item.thumbnailUrl !== undefined) {
//           return {
//             title: item.headline,
//             url: `/article/${item.id}/`,
//             imageUrl: `https://cdn.elena-elizarova.ru${item.thumbnailUrl}`,
//           };
//         } else {
//           return { title: item.headline, url: `/article/${item.id}/`, imageUrl: `` };
//         }
//       });
//     }
//   })
//   .catch((e) => {
//     if (e.response != undefined && e.response.status == 404) {
//       console.log(e.response.data);
//     }
//     error(e);
//   });

//lastArticles.value = res.data;

//return { list, lastArticles };

return { __sfc: true,categories }
}

}